import React from 'react';
import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import { Box } from '@mui/material';

import CollectionPicker from 'components/CollectionPicker';
import Logout from 'components/Logout';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',

      '& > *:not(:last-child)': {
        marginRight: theme.spacing(2),
      },
    },
  }),
);

interface Props {
  showCollectionPicker?: boolean;
}

const ApplicationBar: React.FC<Props> = ({ showCollectionPicker = true }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      {showCollectionPicker && <CollectionPicker />}
      <Logout />
    </Box>
  );
};

export default ApplicationBar;
